/* About page reveal plus sticky shop chrome after the hero. */
(() => {
  'use strict';

  const selector = '[data-torque-about-v6]';
  function init(root) {
  if (!root || root.dataset.torqueAboutInitialized === 'true') return;
  root.dataset.torqueAboutInitialized = 'true';

  const header = root.querySelector('header.site');
  const ticker = root.querySelector('.ticker');
  const hero = root.querySelector('#top');
  const buybar = root.querySelector('#buybar');
  const mcta = root.querySelector('#mcta');
  const mobileQuery = window.matchMedia('(max-width: 720px)');

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.12 });
  root.querySelectorAll('.rv').forEach((el) => io.observe(el));

  function stickyHeight() {
    return Math.ceil((header?.getBoundingClientRect().height || 0) + (ticker?.getBoundingClientRect().height || 0));
  }

  function syncChrome() {
    if (!hero || !buybar || !mcta) return;
    const pastHero = hero.getBoundingClientRect().bottom <= stickyHeight();
    buybar.classList.toggle('show', pastHero && !mobileQuery.matches);
    mcta.classList.toggle('show', pastHero && mobileQuery.matches);
  }

  window.addEventListener('scroll', syncChrome, { passive: true });
  window.addEventListener('resize', syncChrome, { passive: true });
  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncChrome);
  } else {
    mobileQuery.addListener(syncChrome);
  }
  syncChrome();
  const sizes = new ResizeObserver(syncChrome);
  [header, ticker, hero].filter(Boolean).forEach(element => sizes.observe(element));
  root._torqueAboutDestroy = () => {
    io.disconnect();
    sizes.disconnect();
    window.removeEventListener('scroll', syncChrome);
    window.removeEventListener('resize', syncChrome);
    if (typeof mobileQuery.removeEventListener === 'function') mobileQuery.removeEventListener('change', syncChrome);
    else mobileQuery.removeListener(syncChrome);
    delete root.dataset.torqueAboutInitialized;
    delete root._torqueAboutDestroy;
  };
  }
  function roots(scope) {
    return [scope, ...(scope.querySelectorAll?.(selector) || [])].filter(node => node.matches?.(selector));
  }
  const boot = (scope = document) => roots(scope).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  if (document.documentElement.dataset.torqueAboutLifecycle !== 'true') {
    document.documentElement.dataset.torqueAboutLifecycle = 'true';
    document.addEventListener('shopify:section:load', event => boot(event.target));
    document.addEventListener('shopify:section:unload', event => roots(event.target).forEach(root => root._torqueAboutDestroy?.()));
  }
})();
